import PreviewColorModel from "./preview-colors/preview-color/PreviewColorModel.js";
import PreviewEffectModel from "./preview-effects/preview-effect/PreviewEffectModel.js";
import PreviewMaskModel from "./preview-mask/PreviewMaskModel.js";
export default class MockupPreviewDynamicModel {
  constructor({
    id = null,
    order = null,
    active = true,
    scale = 0.95,
    translateX = 0,
    translateY = 0,
    destroy = false,

    stampX1 = null,
    stampY1 = null,
    stampX2 = null,
    stampY2 = null,
    stampX3 = null,
    stampY3 = null,
    stampX4 = null,
    stampY4 = null,
    positionX = 0,
    positionY = 0,
    previewMask = {},
    previewEffects = [],
    previewColors = [],
    stores = [],
  }) {
    this.id = id;
    this.jsClass = "MockupPreviewDynamicModel";
    this.order = order;
    this.active = active;
    this.scale = scale;
    this.translateX = translateX;
    this.translateY = translateY;
    this.destroy = destroy;

    this.stampX1 = stampX1;
    this.stampY1 = stampY1;
    this.stampX2 = stampX2;
    this.stampY2 = stampY2;
    this.stampX3 = stampX3;
    this.stampY3 = stampY3;
    this.stampX4 = stampX4;
    this.stampY4 = stampY4;
    this.positionX = positionX;
    this.positionY = positionY;
    this.previewMask = this.mountPreviewMask(previewMask);
    this.previewEffects = this.mountPreviewEffects(previewEffects);
    this.previewColors = this.mountPreviewColors(previewColors);
    this.stores = stores;
  }

  json = () => {
    return {
      id: this.id,
      jsClass: this.jsClass,
      order: this.order,
      active: this.active,
      scale: this.scale,
      translateX: this.translateX,
      translateY: this.translateY,
      destroy: this.destroy,

      stampX1: this.stampX1,
      stampY1: this.stampY1,
      stampX2: this.stampX2,
      stampY2: this.stampY2,
      stampX3: this.stampX3,
      stampY3: this.stampY3,
      stampX4: this.stampX4,
      stampY4: this.stampY4,
      positionX: this.positionX,
      positionY: this.positionY,
      previewMask: this.previewMask.json(),
      previewEffects: this.previewEffects.map((p) => (p.json ? p.json() : el)),
      previewColors: this.previewColors.map((p) => (p.json ? p.json() : el)),
      stores: this.stores,
    };
  };

  mountPreviewColors = (previewColors) =>
    previewColors.map((el) => new PreviewColorModel(el || {}));

  mountPreviewEffects = (previewEffects) =>
    previewEffects.map((el) => new PreviewEffectModel(el || {}));

  mountPreviewMask = (previewMask) => new PreviewMaskModel(previewMask || {});

  addPreviewColor = (hash) =>
    this.previewColors.push(new PreviewColorModel(hash));

  addPreviewEffect = (hash) =>
    this.previewEffects.push(new PreviewEffectModel(hash));

  addPreviewMask = (hash) => this.previewMask.updateValues(hash);
}
